// DashboardClusterMonitor.jsx

import ProtectedGrafanaFrame from "./components/ProtectedGrafanaFrame";

const DashboardClusterMonitor = () => {
  const grafanaClusterDashboardUrl =
    "/grafana/d/cluster-summary/efabric-cluster-summary?orgId=1&var-nodename=All&kiosk";

  return (
    <ProtectedGrafanaFrame
      src={grafanaClusterDashboardUrl}
      title="Cluster Monitor Dashboard"
      sx={{
        height: `calc(100vh - ${60}px)`,
      }}
    />
  );
};

export default DashboardClusterMonitor;
